require('./accountDirectDebitWaitingStep.scss');

// @vendors
const React = require('react');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

class AccountDirectDebitWaitingStep extends React.Component {
    render() {
        return (
            <div className="wizard-wating-step col-xs-9 center-block">
                <i className="wizard-wating-step__icon-tiempo icon-tiempo"></i>
                <div className="wizard-wating-step__error-message">
                    <OKBoxTitle value={formatText('accountDirectDebitWaiting-title')}/>
                </div>
            </div>
        );
    }
}

module.exports = AccountDirectDebitWaitingStep;
